import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TypeCesEnum } from 'src/app/domain/registration/enums/type-ces.enum';
import * as moment from 'moment';
import { IFieldConfig } from 'src/app/domain/IFieldConfig';

@Component({
  selector: 'app-time-picker',
  templateUrl: './time-picker.component.html',
  styleUrls: ['./time-picker.component.sass'],
})
export class TimePickerComponent implements OnInit {
  @Input()
  config: IFieldConfig;
  @Input()
  group: FormGroup;
  typeCes?: TypeCesEnum | undefined;

  selectedDate?: moment.Moment = moment(new Date());

  constructor() {}

  ngOnInit(): void {}
}
